import "./Page.css";

import Component from "react-pure-render/component";
import DocumentTitle from "react-document-title";
import React from "react";
import Button from "../components/Button.react";
import { Link } from "react-router";

export default class NotFoundIndex extends Component {
  static propTypes = {
    msg: React.PropTypes.object
  };

  redirectToLastPage = () => {
    window.history.back();
  };

  render() {
    const { msg: { notFound: msg } } = this.props;

    return (
      <DocumentTitle title={msg.title}>
        <div className="auth-page row center-xs middle-xs">
          <div className="background" />
          <div className="auth-box">
            <img
              className="logo-pq"
              src="/assets/img/logo.svg"
              alt="PQ studio"
            />
            <h2>Nie ma takiej strony</h2>
            <h5>Kod błędu: 404</h5>
            <Button
              info
              onClick={this.redirectToLastPage}
              text="Powrót do poprzedniej strony"
            />
            Podana strona nie istnieje. Wróć do poprzedniej strony, bądź zgłoś
            błąd do PQstudio. tel.: <strong>882 153 932</strong>
            <br /> email: <strong>support@pqstudio.pl</strong>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/auth/Notfound.react.js